export default __webpack_public_path__ + "static/media/fidelity.76ceda4e.svg";